import api from './api';
import { isFeatureNotActivatedError, FEATURE_NOT_ACTIVATED_MESSAGE } from '../utils/apiError';

/*
 * ТЗ V5 №12: изображения объектов, подразделений, областей и локаций.
 *
 * Загрузка — сырые байты файла с Content-Type картинки (не multipart и не
 * Base64), backend кладёт файл в хранилище и пишет в поле image внутренний
 * ключ. Ключ — не ссылка: показывать картинку можно только через
 * GET /entity-images/{type}/{id}, который отдаёт байты с проверкой прав.
 * Старые значения image (внешние ссылки) показываются как раньше.
 */

export const ENTITY_IMAGE_TYPES = ['factory', 'workshop', 'section', 'room'];

const MANAGED_PREFIX = 'entity-images/';

export const isManagedImageKey = (image) => typeof image === 'string' && image.startsWith(MANAGED_PREFIX);

export const uploadEntityImage = (entityType, entityId, file) =>
  api
    .post(`/admin/entity-images/${entityType}/${entityId}`, file, {
      headers: { 'Content-Type': file.type },
      // Файл уходит как есть: axios не должен сериализовать Blob в JSON.
      transformRequest: [(data) => data],
    })
    .then((response) => response.data);

export const deleteEntityImage = (entityType, entityId) =>
  api.delete(`/admin/entity-images/${entityType}/${entityId}`).then((response) => response.data);

/** Временная ссылка на картинку; null — изображения нет (404). */
export const fetchEntityImageUrl = (entityType, entityId) =>
  api
    .get(`/entity-images/${entityType}/${entityId}`, { responseType: 'blob' })
    .then((response) => URL.createObjectURL(response.data))
    .catch((error) => {
      if (error?.response?.status === 404) return null;
      throw error;
    });

const UPLOAD_ERRORS = {
  403: 'Недостаточно прав для изменения изображения',
  404: 'Объект не найден',
  413: 'Файл больше 5 МБ',
  415: 'Подходят только JPG, PNG и WebP',
  422: 'Файл повреждён или изображение слишком большое',
  503: 'Хранилище изображений временно недоступно',
};

export const describeEntityImageError = (error) => {
  if (isFeatureNotActivatedError(error)) return FEATURE_NOT_ACTIVATED_MESSAGE;
  const status = error?.response?.status;
  if (status === 401) return 'Нужно войти заново';
  return UPLOAD_ERRORS[status] || 'Не удалось сохранить изображение';
};
